/**
 * API Configuration - Generated during deployment
 * Environment: staging
 * Generated at: 2025-09-26T19:54:57.655Z
 */

/**
 * Get the API endpoint for the current environment
 * @returns {string} The API endpoint URL
 */
export function getApiEndpoint() {
    // Build-time injected endpoint (this is the deployed API Gateway URL)
    const deployedEndpoint = 'https://c2wfrqhy2b.execute-api.eu-west-1.amazonaws.com/staging/share';
    
    // Environment-based detection for development override
    const hostname = (typeof window !== 'undefined' && window.location) 
        ? window.location.hostname 
        : 'localhost';

    const isDevelopment = hostname === 'localhost' || 
                         hostname === '127.0.0.1' ||
                         hostname.includes('localhost');

    if (isDevelopment) {
        // For development, use localhost API endpoint
        return 'http://localhost:3001/api/share';
    }

    // Use the deployed endpoint
    return deployedEndpoint;
}

/**
 * Get the feedback API endpoint for the current environment
 * @returns {string} The feedback API endpoint URL
 */
export function getFeedbackApiEndpoint() {
    // Build-time injected endpoint (this is the deployed API Gateway URL)
    const deployedEndpoint = 'https://c2wfrqhy2b.execute-api.eu-west-1.amazonaws.com/staging/feedback';
    
    // Environment-based detection for development override
    const hostname = (typeof window !== 'undefined' && window.location) 
        ? window.location.hostname 
        : 'localhost';

    const isDevelopment = hostname === 'localhost' || 
                         hostname === '127.0.0.1' ||
                         hostname.includes('localhost');

    if (isDevelopment) {
        // For development, use localhost API endpoint
        return 'http://localhost:3001/api/feedback';
    }

    // Use the deployed endpoint
    return deployedEndpoint;
}

/**
 * Initialize API configuration
 * This can be called during app startup to validate the endpoint
 */
export function initializeApiConfig() {
    const endpoint = getApiEndpoint();
    console.log('API endpoint initialized:', endpoint);
    return endpoint;
}

export default {
    getApiEndpoint,
    getFeedbackApiEndpoint,
    initializeApiConfig
};